import { render, staticRenderFns } from "./CenterLineText.vue?vue&type=template&id=2407535b&scoped=true&"
import script from "./CenterLineText.vue?vue&type=script&lang=js&"
export * from "./CenterLineText.vue?vue&type=script&lang=js&"
import style0 from "./CenterLineText.vue?vue&type=style&index=0&id=2407535b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407535b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
